import { render, staticRenderFns } from "./Permissions.vue?vue&type=template&id=e18b7df4&scoped=true"
import script from "./Permissions.vue?vue&type=script&lang=js"
export * from "./Permissions.vue?vue&type=script&lang=js"
import style0 from "./Permissions.vue?vue&type=style&index=0&id=e18b7df4&prod&lang=scss"
import style1 from "./Permissions.vue?vue&type=style&index=1&id=e18b7df4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e18b7df4",
  null
  
)

export default component.exports